import { Button, Popover } from "antd";
import { cloneDeep, forEach, isEmpty, noop } from "lodash";
import moment from "moment";
import React, { FC, useEffect, useState } from "react";

import NotesAction from "@pages/members/components/notes";
import Icon from "@assets/icon_config";
import { Info } from "../../constants";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import {USER_ACTION_MODULE_MEMBER_DETAIL, USER_ACTION_TAB_CARE_MANAGEMENT, USER_ACTION_LOCATION_PROGRAM} from "@utils/constants";
import useSession from "@utils/useSession";

const Notes: FC<any> = ({ masterData, screen, page, patientId, noteType, disabled, updateParentTask = noop, taskType, taskId, interventionId, measureId, category, measureName, sectionName }) => {
  const updatedNotes = useCareCoordinationStore((state) => state.updatedNotes);
  const setUpdatedNotes = useCareCoordinationStore((state) => state.setUpdatedNotes);
  const session = useSession();

  const [isNoteVisible, setIsNoteVisible] = useState(false);
  const [notesData, setNotesData] = useState(masterData?.notes || []);

  useEffect(() => {
    setNotesData(masterData?.notes || []);
  }, [masterData]);

  let updatedNotesList = notesData?.filter((note: any) => {
    return !updatedNotes.deletedNotes.includes(Number(note.notesId));
  }).map((note:any) => {
    let tempNote = {...note};
    forEach(updatedNotes.editedNotes, localNote => {
      if(Number(note.notesId) === Number(localNote?.notesId)){
        if(localNote?.notes)tempNote.notes=localNote.notes;
        if(Object.keys(localNote).includes("isBookMarked"))tempNote.isBookMarked=localNote.isBookMarked;
      }
    })
    if(tempNote.isBookMarked==="true")tempNote.isBookMarked=true;
    else if(tempNote.isBookMarked==="false")tempNote.isBookMarked=false;
    return tempNote;
  });


  const noteEditHandler = (updatedContent: any, notesId: any) => {
    let updated = cloneDeep(notesData).map((item: any) => {
      return item.notesId !== notesId ? item : { ...item, notes: updatedContent.description, patientId: updatedContent.patientId, notesCreateDate: moment.utc(), isBookMarked: updatedContent.isBookmarked, recipientType: updatedContent.recipientType};
    });

    let tempUpdatedNotes = cloneDeep(updatedNotes);
    let isUpdatednoteExists = false;
    let tempNote = {
      notesId: notesId,
      notes: updatedContent.description
    };

    forEach(updatedNotes.editedNotes, (note, index) => {
      if(Number(note.notesId) === Number(notesId)){
        isUpdatednoteExists = true;
        tempUpdatedNotes.editedNotes[index] = {
          ...note,
          ...tempNote
        };
      }
    })
    if(!isUpdatednoteExists)tempUpdatedNotes.editedNotes.push(tempNote);
    setUpdatedNotes(tempUpdatedNotes);
    
    setNotesData(updated);
    masterData.notes = updated;
  };

  const addNoteHandler = (note: any) => { 
    let copyData = cloneDeep(notesData);
    let noteItem: any = {
      isBookMarked: note.isBookmarked,
      notes: note?.data?.description,
      notesCreateDate: moment(new Date()),
      notesId: note?.data?.noteId,
      recipientType: note?.data?.recipientType,
      careMgrFirstName: session?.user?.firstName,
      careMgrLastName: session?.user?.lastName,
      careMgrId: session?.user?.id
    };

    if (note?.data?.category) {
      noteItem.category = note.data.category;
    }

    copyData.unshift(noteItem);

    setNotesData(copyData);
    setIsNoteVisible(!isNoteVisible);

    masterData.notes = copyData;

    if (updateParentTask) {
      updateParentTask();
    }
  };

  const noteDeleteHandler = (notesId: any) => {
    let updated = cloneDeep(notesData).filter((item: any) => {
      return item.notesId !== notesId;
    });
    setNotesData(updated);
    masterData.notes = updated;
  };

  const noteBookmarkHandler = (notesId: any) => {
    // let bookmarkedContainer:any;
    let tempUpdatedNotes = cloneDeep(updatedNotes);
    // let isUpdatednoteExists = false;

    let updated = cloneDeep(notesData).map((item: any) => {
      let noteUpdatedFlag = false;
      if (item.notesId === notesId) {
        forEach(updatedNotes.editedNotes, (note, index) => {
          if(Number(note.notesId) === Number(notesId)){
            noteUpdatedFlag = true;
            item.isBookMarked = !(note.isBookMarked==="true" || note.isBookMarked===true ? true : false);
            tempUpdatedNotes.editedNotes[index] = {
              ...note,
              isBookMarked:item.isBookMarked
            };
            setUpdatedNotes(tempUpdatedNotes);
          }
        })
        // item.isBookMarked = item.isBookMarked === 'true'? "false" : "true";
        if(!noteUpdatedFlag)item.isBookMarked = !(item.isBookMarked==="true" || item.isBookMarked===true ? true : false);
        // bookmarkedContainer = item;
      }
      return item;
    });

    setNotesData(updated);
    masterData.notes = updated;

  };

  const [activeMeasureContext, setActiveMeasureContext] = useState({
    measureId: null,
    category: null,
    measureName: null,
    sectionName: ""
  });

  return (
    <>
      {isNoteVisible && <div className="overlay-modal"></div>}
      <Popover
        trigger="click"
        overlayClassName="notesPopoverOverlay"
        visible={isNoteVisible}
        content={
          <NotesAction
            data={updatedNotesList}
            screen={screen}
            editHandler={noteEditHandler}
            deleteHandler={noteDeleteHandler}
            addNoteHanlder={addNoteHandler}
            bookmarkHandler={noteBookmarkHandler}
            page={page}
            patientId={patientId}
            taskId={taskId}
            interventionId={interventionId}
            noteType={noteType}
            closePopOver={() => setIsNoteVisible(!isNoteVisible)}
            disabled={disabled}
            measureId={activeMeasureContext.measureId}
            category={activeMeasureContext.category}
            measureName={activeMeasureContext.measureName}
            sectionName={activeMeasureContext.sectionName}
          />
        }
        placement="right"
        destroyTooltipOnHide={true}
      >
        <Button
          disabled={taskType === Info}
          icon={<Icon name="note" colorOfBrand={!isEmpty(updatedNotesList) ? "#d15f25" : "#7A869A"} />}
          title="Add Note"
          type="text"
          onClick={() => {
            setActiveMeasureContext({
              measureId: measureId,
              category: category,
              measureName: measureName,
              sectionName: sectionName
            });
            setIsNoteVisible(!isNoteVisible);
          }}
        />
      </Popover>
    </>
  );
};

export default Notes;
